import { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

interface BarcodeDisplayProps {
  value: string;
  width?: number;
  height?: number;
  showText?: boolean;
  className?: string;
}

export function BarcodeDisplay({
  value,
  width = 2,
  height = 50,
  showText = true,
  className = '',
}: BarcodeDisplayProps) {
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (svgRef.current && value) {
      try {
        // Ensure a minimum total barcode width (~300px) so phone cameras can reliably scan
        // short codes. CODE128B has (n+3) symbols × 11 modules + 20 quiet-zone modules.
        const totalModules = (value.length + 3) * 11 + 20;
        const minBarWidth = Math.ceil(300 / totalModules);
        const effectiveWidth = Math.max(width, minBarWidth);

        JsBarcode(svgRef.current, value, {
          format: 'CODE128B',
          width: effectiveWidth,
          height,
          displayValue: showText,
          background: '#ffffff',
          lineColor: '#000000',
          margin: 10,
          fontSize: 14,
          font: 'monospace',
        });
      } catch {
        // Invalid barcode value - clear the SVG
        if (svgRef.current) {
          svgRef.current.innerHTML = '';
        }
      }
    }
  }, [value, width, height, showText]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!value) {
    return null;
  }

  return <svg ref={svgRef} className={className} />;
}
